module.exports = __webpack_public_path__ + "img/layout-bgshape.c475df37.svg";